import React, { FC } from "react";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { MenuItem } from "@mui/material";
import NumberFormatCustom from "../NumberFormatCustom";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useJambInputSelector from "./useJambInputSelector";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 100,
  position: "relative",
}));

const StyledForm = styled("form")(({ theme }) => ({
  "& > *": {
    margin: theme.spacing(1),
    width: "25ch",
  },
}));

interface JambInputProps {
  fraction: string;
  jamb: string;
}

const JambInput: FC<JambInputProps> = ({ fraction, jamb }) => {
  const { upcharge, handleChangeFraction, handleChange, jambErr } =
    useJambInputSelector(jamb, fraction);

  return (
    <>
      <ColLayout>
        {upcharge && (
          <Typography variant="caption">
            * Upcharge if wider than {upcharge}
          </Typography>
        )}

        <StyledForm
          onSubmit={(e) => {
            e.preventDefault();
          }}
          noValidate
          autoComplete="off"
        >
          <ColLayout>
            <TextField
              variant="outlined"
              label="Enter Overall Width"
              value={jamb}
              error={jambErr ? true : false}
              helperText={jambErr || ""}
              onChange={handleChange}
              name="jamb"
              id="formatted-numberformat-input"
              style={{ width: 200 }}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </ColLayout>
        </StyledForm>
      </ColLayout>

      <RowLayout style={{ alignSelf: jambErr ? "center" : "flex-end" }}>
        <StyledFormControl>
          <InputLabel>fraction</InputLabel>
          <Select
            value={fraction}
            onChange={handleChangeFraction}
            name="fractionValue"
            label="fraction"
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value={"1/16"}>1/16</MenuItem>
            <MenuItem value={"1/8"}>1/8</MenuItem>
            <MenuItem value={"3/16"}>3/16</MenuItem>
            <MenuItem value={"1/4"}>1/4</MenuItem>
            <MenuItem value={"5/16"}>5/16</MenuItem>
            <MenuItem value={"3/8"}>3/8</MenuItem>
            <MenuItem value={"7/16"}>7/16</MenuItem>
            <MenuItem value={"1/2"}>1/2</MenuItem>
            <MenuItem value={"9/16"}>9/16</MenuItem>
            <MenuItem value={"5/8"}>5/8</MenuItem>
            <MenuItem value={"11/16"}>11/16</MenuItem>
            <MenuItem value={"3/4"}>3/4</MenuItem>
            <MenuItem value={"13/16"}>13/16</MenuItem>
            <MenuItem value={"7/8"}>7/8</MenuItem>
            <MenuItem value={"15/16"}>15/16</MenuItem>
          </Select>
        </StyledFormControl>
      </RowLayout>
    </>
  );
};

export default JambInput;
